import { CSV_IMPORT_KEYS } from '../config/csvImportConfig';

/** Maps CSV import keys to tenant node store keys (when they differ). */
const NODE_KEY_BY_IMPORT_KEY = {
  [CSV_IMPORT_KEYS.facilities]: 'facilities',
  [CSV_IMPORT_KEYS.commodities]: 'commodities',
  [CSV_IMPORT_KEYS.geographies]: 'geographies',
  [CSV_IMPORT_KEYS.logistics]: 'logistics',
  [CSV_IMPORT_KEYS.products]: 'products',
  [CSV_IMPORT_KEYS.supplierFacilities]: 'supplierFacilities',
  [CSV_IMPORT_KEYS.graphOverview]: 'graphRelationships',
};

const nodeRowCount = (nodesByKey, nodeKey) => {
  const rows = nodesByKey?.[nodeKey];
  return Array.isArray(rows) ? rows.length : 0;
};

/**
 * Snapshot of data already stored for each CSV import step.
 * @returns {Record<string, { count: number, summary?: string }>}
 */
export function buildExistingImportByKey({
  profile,
  hasTenantProfile,
  nodesByKey,
  tenantSuppliers,
}) {
  const existing = {};

  if (hasTenantProfile) {
    const summary =
      String(profile?.name || '').trim() ||
      String(profile?.legal_name || '').trim() ||
      '';
    existing[CSV_IMPORT_KEYS.tenantCompany] = {
      count: 1,
      ...(summary ? { summary } : {}),
    };
  }

  const supplierCount = Array.isArray(tenantSuppliers) ? tenantSuppliers.length : 0;
  if (supplierCount > 0) {
    existing[CSV_IMPORT_KEYS.suppliers] = { count: supplierCount };
  }

  Object.entries(NODE_KEY_BY_IMPORT_KEY).forEach(([importKey, nodeKey]) => {
    const count = nodeRowCount(nodesByKey, nodeKey);
    if (count > 0) {
      existing[importKey] = { count };
    }
  });

  return existing;
}

/** Step is done if the last upload created/updated rows, or matching data already exists. */
export function isImportStepSatisfied(importKey, resultsByKey, existingByKey) {
  const result = resultsByKey?.[importKey];
  if (Number(result?.created) > 0 || Number(result?.updated) > 0) {
    return true;
  }
  return Boolean(existingByKey?.[importKey]);
}

export { NODE_KEY_BY_IMPORT_KEY };
